export default "__VITE_ASSET__Rvs5M4BF__"